<div class="message" [class]="type">
    <div class="content">
        <ng-content></ng-content>
    </div>
    @if (dismissible) {
    <txp-button class="close-button"
                data-qa-label="DismissButton"
                [style]="buttonStyle"
                icon="tce-icon-close"
                (click)="dismiss.emit()">
    </txp-button>
    }
</div>
